import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAWsfA5BZ2hrehMLH2DoDAzisj6qqhA1DE",
  authDomain: "buscakine-24e9d.firebaseapp.com",
  projectId: "buscakine-24e9d",
  storageBucket: "buscakine-24e9d.firebasestorage.app",
  messagingSenderId: "820123642133",
  appId: "1:820123642133:web:be7255ce7b0fe4404ce11c",
  measurementId: "G-EBQCPN05TE"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
